module.exports = __webpack_public_path__ + "img/stethoscope-ico.1def464a.svg";